module.exports = __webpack_public_path__ + "media/customer_tickets/truck-6cc17489.svg";